const setWAinsuranceType = (category) => {
  switch (category) {
    case 'health':
      return 'kesehatan';
    case 'life':
      return 'jiwa';
    case 'auto':
      return 'mobil';
    default:
      return '';
  }
};

const setWAphoneNumber = (category) => {
  if (category === 'health' || category === 'life') {
    return '6281284570583';
  } else {
    return '6285649031559';
  }
};

interface IRedirectWhatsapp {
  fullName: string;
  category: string;
}

const redirectWhatsapp = (data: IRedirectWhatsapp) => {
  const text =
    `Halo, saya memiliki pertanyaan tentang produk asuransi ` +
    setWAinsuranceType(data.category) +
    '\n' +
    `Nama: ${data.fullName}` +
    '\n' +
    `Kategori Asuransi: ${setWAinsuranceType(data.category)}`;

  const WhatsappAPI = `https://api.whatsapp.com/send/?phone=${setWAphoneNumber(data.category)}&text=${encodeURIComponent(text)}&app_absent=0`;

  window.location.href = WhatsappAPI;
};

export default redirectWhatsapp;
